export default "__VITE_PUBLIC_ASSET__4eeaee0a__"